import { Entity } from '@backstage/catalog-model';

const AUTOMATIC_DEPLOYMENT_METADATA = 'automaticDeployment';
const ENVIRONMENT = 'environment';
const BRANCH_REGEX = 'branchRegex';
const RELEASE_TAG_REGEX = 'releaseTagRegex';

export const isAutomaticDeploymentMetadataAvailable = (entity: Entity) =>
  Boolean(entity?.metadata?.[AUTOMATIC_DEPLOYMENT_METADATA]);

export const getEnvironment = (entity: Entity): string | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[AUTOMATIC_DEPLOYMENT_METADATA]?.[ENVIRONMENT] ?? undefined;
};
export const getBranchRegex = (entity: Entity): string[] | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[AUTOMATIC_DEPLOYMENT_METADATA]?.[BRANCH_REGEX] ?? undefined;
};
export const getReleaseTagRegex = (entity: Entity): string[] | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return (
    metadata?.[AUTOMATIC_DEPLOYMENT_METADATA]?.[RELEASE_TAG_REGEX] ?? undefined
  );
};
